export function startMatomo(basePath: string, matomoId: string) {
    if (!matomoId) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://${basePath}/js/container_${matomoId}.js`;
    document.head.appendChild(script);
}
